import { render, staticRenderFns } from "./ManageOffice.vue?vue&type=template&id=610a0252&scoped=true&"
import script from "./ManageOffice.vue?vue&type=script&lang=js&"
export * from "./ManageOffice.vue?vue&type=script&lang=js&"
import style0 from "./ManageOffice.vue?vue&type=style&index=0&id=610a0252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610a0252",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610a0252')) {
      api.createRecord('610a0252', component.options)
    } else {
      api.reload('610a0252', component.options)
    }
    module.hot.accept("./ManageOffice.vue?vue&type=template&id=610a0252&scoped=true&", function () {
      api.rerender('610a0252', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/ManageOffice.vue"
export default component.exports